import axios from "axios";

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
  responseEncoding: "utf8",
  timeout: 1000 * 1000,
});
